<template>
  <div class="wraper">
    <template>
    <el-backtop target=".wraper" :bottom="100">
      <div
        style="{
        height: 100%;
        width: 100%;
        border-radius: inherit;
        background-color: #f2f5f6;
        box-shadow: 0 0 6px rgba(0,0,0, .12);
        text-align: center;
        line-height: 40px;
        color: #1989fa;
      }"
      >
        UP
      </div>
    </el-backtop>
    </template>
  <el-container >
    <el-header >
      <!--        <top-header @title-search="toChildMsg"/>-->
      <video-header @title-search="toChildMsg"/>
    </el-header>
    <el-main>
<!--      <video-detail v-bind:id="$route.params.id "/>-->
      <order-center v-bind:id="$route.params.id " />
    </el-main>
    <el-footer>
      <app-footer/>
    </el-footer>

  </el-container>
  </div>
</template>

<script>
  import OrderCenter from './orderCenter'
  import {TopHeader,AppFooter,VideoHeader} from '@/layout/components'

  export default {
        name: "index",
        components: {TopHeader,AppFooter,OrderCenter,VideoHeader},
    }
</script>

<style scoped>
  .wraper {
    height: 100vh;
    overflow-x: hidden;
  }
  .el-footer {
    background-color: #B3C0D1;
    color: #333;
    text-align: center;
  }
  .el-header{
    background-color: white;
    color: #333;
    text-align: center;
    height: 50px;
    position: fixed;
    width: 100%;
    z-index: 999;
    top: 0;
  }
  .el-footer{
    /*margin-top: 50px;*/
    position: relative;
    padding: 0px;
    text-align: left;
  }
  .el-main {
    /*background-color: #E9EEF3;*/
    color: #333;
    /*text-align: center;*/
    position: relative;
    margin-top: 50px;
    padding: 0px;
  }


  body > .el-container {
    margin-bottom: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/views/selforders/index.vue